import React from 'react';
import { Grid, Checkbox, FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import IncomeSourceDetailValueListCard from './IncomeSourceDetailValueListCard';
import { Autocomplete, TextField } from '@totalsoft/rocket-ui';
import PropTypes from 'prop-types';
import { Prompt } from 'react-router-dom';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const IncomeSourceDetailComponent = ({ incomeItemDetail, periodTypes, dataTypes, dispatch, index, collectionValidation }) => {
  const { t } = useTranslation();
  const onPropertyChanged = (detailPropertyName, detailValue) => {
    dispatch({ type: 'OnDetailsPropertyChanged', detailPropertyName, detailValue, index });
  };

  return (
    <>
      <Prompt when={incomeItemDetail.changed} message={t('IncomeSources.LeavingWithoutSavingDetail', { index: index + 1 })} />
      <Grid item container spacing={2}>
        <Grid item xs={12} sm={4}>
          <TextField
            isNumeric
            fullWidth
            value={incomeItemDetail.orderNo}
            onChange={event => onPropertyChanged('orderNo', event)}
            label={t('IncomeSources.Detail.OrderNo')}
            error={!isValid(collectionValidation[index].orderNo)}
            helperText={getErrors(collectionValidation[index].orderNo)}
            decimalScale={0}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            value={incomeItemDetail.code || ''}
            onChange={event => onPropertyChanged('code', event)}
            label={t('IncomeSources.Detail.Code')}
            error={!isValid(collectionValidation[index].code)}
            helperText={getErrors(collectionValidation[index].code)}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            value={incomeItemDetail.name || ''}
            onChange={event => onPropertyChanged('name', event)}
            label={t('IncomeSources.Detail.Name')}
            error={!isValid(collectionValidation[index].name)}
            helperText={getErrors(collectionValidation[index].name)}
          />
        </Grid>
        <Grid item xs={12} sm={8}>
          <TextField
            fullWidth
            value={incomeItemDetail.description || ''}
            onChange={event => onPropertyChanged('description', event)}
            label={t('IncomeSources.Detail.Description')}
            error={!isValid(collectionValidation[index].description)}
            helperText={getErrors(collectionValidation[index].description)}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Autocomplete
            fullWidth
            value={incomeItemDetail.dataTypeId}
            simpleValue
            options={dataTypes}
            onChange={event => onPropertyChanged('dataTypeId', event)}
            label={t('IncomeSources.Detail.DataType')}
            error={!isValid(collectionValidation[index].dataTypeId)}
            helperText={getErrors(collectionValidation[index].dataTypeId)}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormControlLabel
            control={
              <Checkbox
                checked={incomeItemDetail.isActive || false}
                onChange={event => onPropertyChanged('isActive', event.target.checked)}
                color='primary'
              />
            }
            label={t('IncomeSources.Detail.IsActive')}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormControlLabel
            control={
              <Checkbox
                checked={incomeItemDetail.isSummary || false}
                onChange={event => onPropertyChanged('isSummary', event.target.checked)}
                color='primary'
              />
            }
            label={t('IncomeSources.Detail.IsSummary')}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <FormControlLabel
            control={
              <Checkbox
                checked={incomeItemDetail.isReadOnly || false}
                onChange={event => onPropertyChanged('isReadOnly', event.target.checked)}
                color='primary'
              />
            }
            label={t('IncomeSources.Detail.Readonly')}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Autocomplete
            fullWidth
            value={incomeItemDetail.periodTypeId}
            simpleValue
            options={periodTypes}
            onChange={event => onPropertyChanged('periodTypeId', event)}
            label={t('IncomeSources.Detail.PeriodType')}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            value={incomeItemDetail.formula || ''}
            onChange={event => onPropertyChanged('formula', event)}
            label={t('IncomeSources.Detail.Formula')}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            value={incomeItemDetail.validationFormula || ''}
            onChange={event => onPropertyChanged('validationFormula', event)}
            label={t('IncomeSources.Detail.ValidationFormula')}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            value={incomeItemDetail.validationMessage || ''}
            onChange={event => onPropertyChanged('validationMessage', event)}
            label={t('IncomeSources.Detail.ValidationMessage')}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <IncomeSourceDetailValueListCard
            incomeItemDetailValues={incomeItemDetail.detailValues}
            detailId={incomeItemDetail.id}
            detailIndex={index}
            loading={false}
            dispatch={dispatch}
          />
        </Grid>
      </Grid>
    </>
  );
};

IncomeSourceDetailComponent.propTypes = {
  incomeItemDetail: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  periodTypes: PropTypes.array,
  dataTypes: PropTypes.array,
  collectionValidation: PropTypes.object.isRequired
};
export default IncomeSourceDetailComponent;
